"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _reactSpring = require("react-spring");
var _querystring = require("../../helpers/querystring");
var _newComponents = require("../../new-components");
var _index = require("../../index");
var _BookingNavbarLink = _interopRequireDefault(require("./BookingNavbarLink"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var navDisabled = function navDisabled(pathname, currentPathname, pathOrder) {
  var currentOrder = pathOrder[currentPathname];
  var navOrder = pathOrder[pathname];
  return navOrder > currentOrder;
};
var BookingNavbar = function BookingNavbar(_ref) {
  var location = _ref.location,
    routes = _ref.routes,
    pathOrder = _ref.pathOrder,
    supportedCurrencies = _ref.supportedCurrencies,
    logoSite = _ref.logoSite,
    homePath = _ref.homePath,
    title = _ref.title,
    showContact = _ref.showContact,
    contactIconColor = _ref.contactIconColor,
    isPoweredBy = _ref.isPoweredBy;
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    measureActiveLink = _useState2[0],
    setActiveLink = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    activeLinkOffset = _useState4[0],
    setActiveLinkOffset = _useState4[1];
  var _useMeasure = (0, _index.useMeasure)(),
    _useMeasure2 = (0, _slicedToArray2["default"])(_useMeasure, 2),
    refBookingNavbarVisible = _useMeasure2[0],
    measureBookingNavbarVisible = _useMeasure2[1];
  var _useMeasure3 = (0, _index.useMeasure)(routes === null || routes === void 0 ? void 0 : routes.length),
    _useMeasure4 = (0, _slicedToArray2["default"])(_useMeasure3, 2),
    refBookingNavbar = _useMeasure4[0],
    measureBookingNavbar = _useMeasure4[1]; // this will trigger updating of measure when number of routes changes
  var isAnimationNeeded = activeLinkOffset > 0 && measureBookingNavbarVisible.width < measureBookingNavbar.width;
  var _useSpring = (0, _reactSpring.useSpring)({
      x: isAnimationNeeded ? activeLinkOffset : 0
    }),
    x = _useSpring.x;
  (0, _react.useEffect)(function () {
    var linkOffset = measureActiveLink.x + measureActiveLink.width / 2 - measureBookingNavbarVisible.width / 2;
    var maxOffset = measureBookingNavbar.width - measureBookingNavbarVisible.width;
    var finalOffset = linkOffset < maxOffset ? linkOffset : maxOffset;
    setActiveLinkOffset(finalOffset);
  }, [measureActiveLink]);
  // re-render when number of routes changes so it can recalculate poistions
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_newComponents.Navbar, {
    template: "BookingFunnel",
    showContact: showContact,
    title: title,
    supportedCurrencies: supportedCurrencies,
    sticky: false,
    logoSite: logoSite,
    homePath: homePath,
    contactIconColor: contactIconColor,
    isPoweredBy: isPoweredBy
  }), !!(routes !== null && routes !== void 0 && routes.length) > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center d8-c-current-section",
    style: {
      zIndex: 'var(--zindex-header)'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: refBookingNavbarVisible,
    className: "d8-u-overflow-hidden d8-u-relative width-100%"
  }, /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    ref: refBookingNavbar,
    className: "inline-flex flex-center@sm",
    style: {
      transform: x.to(function (x) {
        return "translateX(-".concat(x, "px)");
      })
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    exact: true,
    to: {
      pathname: routes[0].pathname,
      search: (0, _querystring.getQuery)(location).referral ? "referral=".concat((0, _querystring.getQuery)(location).referral) : location.search
    }
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
    text: routes[0].title,
    buttonType: _newComponents.BUTTON_TYPES.FILTER_PROGRESS,
    active: routes[0].pathname === location.pathname
  })), routes.slice(1).map(function (route) {
    var disabled = navDisabled(route.pathname, location.pathname, pathOrder);
    return /*#__PURE__*/_react["default"].createElement(_BookingNavbarLink["default"], {
      key: "".concat(route.title).concat(route.pathname),
      route: route,
      routesCount: routes.length,
      location: location,
      disabled: disabled,
      active: route.pathname === location.pathname,
      setActiveLink: setActiveLink
    });
  })))));
};
BookingNavbar.propTypes = {
  location: _propTypes["default"].object.isRequired,
  routes: _propTypes["default"].array,
  pathOrder: _propTypes["default"].object.isRequired,
  supportedCurrencies: _propTypes["default"].array,
  logoSite: _propTypes["default"].string,
  homePath: _propTypes["default"].string,
  title: _propTypes["default"].string,
  showContact: _propTypes["default"].bool,
  contactIconColor: _propTypes["default"].string,
  isPoweredBy: _propTypes["default"].bool
};
BookingNavbar.defaultProps = {
  title: 'Booking'
};
var _default = exports["default"] = BookingNavbar;